<mat-toolbar>{{"Select Customer To Add" | translate | async}}</mat-toolbar>
<div class="DialogBoxCL">
  <div class="SelectUser">
    <!--<h4>User</h4>-->
    <mat-form-field class="MFF">
      <mat-label>{{"Customer" | translate | async}}</mat-label>
      <mat-select [(ngModel)]="selectedCustomer" name="customer" [placeholder]="'Select Customer' | translate | async">
        <mat-option *ngFor="let option of CustomerList" [value]="option.customerId">
          {{option.customerName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <!--<span>userId {{userid}} userName {{usename}} </span>-->
  <div class="DialogBoxCLBtn">
    <button mat-stroked-button class="AddNewUserClAddBtn" (click)="AddNewCustomer()">{{"Add" | translate | async}}</button>
    <button mat-stroked-button class="AddNewUserClClsBtn" (click)="DialogClose()">{{"Close" | translate | async}}</button>
  </div>
</div>